import { render } from "./Index.vue?vue&type=template&id=7605fe48"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"components/Home/Testimonials/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7605fe48"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7605fe48', __exports__)) {
    api.reload('7605fe48', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=7605fe48", () => {
    api.rerender('7605fe48', render)
  })

}


export default __exports__